module.exports = __webpack_public_path__ + "img/puzzle_13.f9aa9f7a.png";